import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { catchError, finalize, of, tap } from "rxjs";
import { LoaderService } from "src/app/shared/components/loader/loader.service";
import { ViewContextHistoryStateService } from "src/app/shared/services/view-context-history-state.service";
import {
  describeApiRequestFailed,
  describeRouteEntered,
  extractSupportErrorMessage,
} from "src/app/shared/helpers/contact-support-history.helper";
import { UserProfile } from "./profile.model";
import { ProfileService } from "./profile.service";

/** Fetches user profile data before activating the profile route. GET /user/me */
export const profileResolver: ResolveFn<UserProfile | null> = (route) => {
  const profileService = inject(ProfileService);
  const loaderService = inject(LoaderService);
  const viewContextHistorySvc = inject(ViewContextHistoryStateService);

  const cachedProfile = profileService.userProfile();

  loaderService.show();

  const profile$ = cachedProfile
    ? of(cachedProfile)
    : profileService.getUserProfile();

  return profile$.pipe(
    tap((profileData) => {
      viewContextHistorySvc.createContext({
        titleView: "Profile",
        eventAction: "route_entered",
        eventDescription: describeRouteEntered("Profile"),
        thisState: { profileData },
        route,
        setAutomaticallyScreenshot: false,
      });
    }),
    catchError((error) => {
      console.error("Error resolving profile:", error.status, error.message);

      viewContextHistorySvc.createContext({
        titleView: "Profile",
        eventAction: "route_entered",
        eventDescription: describeApiRequestFailed(
          "load profile in resolver",
          extractSupportErrorMessage(error),
          { status: error.status },
        ),
        thisState: {
          error: { message: error.message, status: error.status },
        },
        route,
        setAutomaticallyScreenshot: false,
      });

      return of(null);
    }),
    finalize(() => loaderService.hide()),
  );
};
